<template>
  <div class="ws-info-datetime">{{_value}}</div>
</template>

<script>
export default {
  computed: {
    _value() {
      if (!this.value) {
        return null;
      } else {
        return this.$moment(this.value).format("YYYY-MM-DD HH:mm:ss");
      }
    },
  },
  props: {
    value: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-info-datetime.scss";
</style>